import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useGetProfile, usePostProfile } from '../hooks/query/user'
import { IUserInfor } from '../models/user'
import { LanguageEnum } from '../until/constant'

interface IProps {
  isAuthenticated: boolean
}

export const ProtectedRoutes: React.FC<IProps> = ({ isAuthenticated }) => {
  const location = useLocation()
  const { data } = useGetProfile()
  const { mutateAsync: mutateProfile } = usePostProfile()
  const lang = localStorage.getItem('lang') || LanguageEnum.JAPANESE
  useEffect(() => {
    if(data && data.lang !== lang){
      const dataProfile = {
        lang: lang || LanguageEnum.JAPANESE,
      } as IUserInfor
      mutateProfile(dataProfile)
    }
  }, [data, lang])  
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />
}
